/**
 * Copyright (C) Firstlight Media. All rights reserved.
 * All information contained herein is and remains the property of Firstlight Media.
 * The intellectual and technical concepts contained herein are proprietary
 * to Firstlight Media. Dissemination of this information or reproduction
 * of this material is strictly forbidden unless prior written permission
 * is obtained from Firstlight Media.
 */

import { PromoPlayerBuilder } from '../PromoPlayerBuilder';
import { AdPlaybackPolicy, Player, Promo, PromoPlayer } from '@quickplay/player-interface';
import { Logger } from '@quickplay/foundation';
import { PromoPlayerImpl } from './PromoPlayer/internal/PromoPlayerImpl';

export function createPromoPlayerBuilder(): PromoPlayerBuilder {
  let internalPlayer_: Player;
  let adPlaybackPolicy_: AdPlaybackPolicy;
  let promos_: Promo[];
  let logger_: Logger;

  return {
    get internalPlayer(): Player {
      return internalPlayer_;
    },

    get adPlaybackPolicy(): AdPlaybackPolicy {
      return adPlaybackPolicy_;
    },

    get promos(): Promo[] {
      return promos_;
    },

    get configuredLogger(): Logger {
      return logger_;
    },

    player(player: Player): PromoPlayerBuilder {
      internalPlayer_ = player;
      return this;
    },

    playbackPolicy(playbackPolicy: AdPlaybackPolicy): PromoPlayerBuilder {
      adPlaybackPolicy_ = playbackPolicy;
      return this;
    },

    withPromos(promos: Promo[]): PromoPlayerBuilder {
      promos_ = promos;
      return this;
    },

    logger(logger: Logger): PromoPlayerBuilder {
      logger_ = logger;
      return this;
    },

    build(): PromoPlayer {
      return new PromoPlayerImpl(internalPlayer_, promos_, adPlaybackPolicy_, logger_);
    },
  };
}
